import React from 'react';
import './reward-item.css';

const RewardItem = ({
  title,
  description,
  points,
  imageUrl,
  canRedeem,
  onRedeem,
  themeColors,
  pointsTerminology = 'points',
}) => {
  const isRedeemable = canRedeem !== false;

  // Capitalize points terminology
  const capitalizedTerminology =
    pointsTerminology.charAt(0).toUpperCase() + pointsTerminology.slice(1);

  return (
    <div className='dashboard-reward-item'>
      <div className='dashboard-reward-item-image'>
        <img src={imageUrl} alt={title} />
      </div>
      <div className='dashboard-reward-item-content'>
        <h4 className='dashboard-reward-item-title'>{title}</h4>
        <p className='dashboard-reward-item-description'>{description}</p>
      </div>
      <div className='dashboard-reward-item-actions'>
        <div className='dashboard-redeem-button-wrapper'>
          <button
            className={`dashboard-redeem-button ${
              !isRedeemable ? 'disabled' : ''
            }`}
            style={{
              backgroundColor: isRedeemable
                ? themeColors.backgroundColor
                : '#ccc',
              opacity: isRedeemable ? 1 : 0.7,
            }}
            onClick={isRedeemable ? onRedeem : undefined}
            disabled={!isRedeemable}
          >
            {isRedeemable ? 'Redeem' : 'Redeem'}
          </button>
        </div>
        <div className='dashboard-reward-item-points'>
          {points.toLocaleString()} {capitalizedTerminology}
        </div>
      </div>
    </div>
  );
};

export default RewardItem;
